export default {"src":"/_next/static/media/slide3.46731a55.svg","height":740,"width":757,"blurWidth":0,"blurHeight":0};